import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from './user/user.service';

@Injectable()
export class AuthGuard {
    constructor(private router: Router, private authService: UserService) { }

    canActivate(state: RouterStateSnapshot): boolean {
        let status_ = false;
        let url_ = state.url.toString();
        this.authService.redirectUrl = url_;
        if (this.authService.isAuthorized()) {
            status_ = true;
        }
        // if(state.url.toString() == 'login') {
        //     if (this.authService.isAuthorized()) {
        //         status_ = true;
        //         this.router.navigate(['/admin']);
        //     }
        // }
        // else {
            
        //}

        if(status_ == false && url_ != 'login') {
            this.router.navigate(['/login']);
        }

        if(status_ == true && url_ == 'login') {
            this.router.navigate(['/admin']);
        }
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/app/app.guard.ts